import React, { useEffect } from "react";
import "./assets/css/style.css";
import AOS from "aos";
import "./App.css";
import "./assets/vendor/aos/aos.css";
import "./assets/vendor/bootstrap/css/bootstrap.min.css";
import "./assets/vendor/bootstrap-icons/bootstrap-icons.css";
import "./assets/vendor/boxicons/css/boxicons.min.css";
import "./assets/vendor/glightbox/css/glightbox.min.css";
import "./assets/vendor/swiper/swiper-bundle.min.css";
//import "https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Raleway:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i"
import HeaderComponent from "./components/header";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/About";
// import Facts from "./components/facts";
import Skills from "./components/skills";
import Resume from "./components/resume";

// import Portfolio from "./components/portfolio";
// import ServiceSection from "./components/Services";
import ContactSection from "./components/Contact";


function App() {
  
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <>
      <HeaderComponent></HeaderComponent>
      <HeroSection></HeroSection>
      <main id="main">
        <AboutSection></AboutSection>
        {/* <Facts></Facts> */}
        <Skills></Skills>
        <Resume></Resume>
        {/* <Portfolio></Portfolio>
        <ServiceSection></ServiceSection> */}
        <ContactSection></ContactSection>
      </main>
    </>
  );
}

export default App;
